import posthog from 'posthog-js';

const key = import.meta.env.VITE_POSTHOG_KEY as string | undefined;
const host = (import.meta.env.VITE_POSTHOG_HOST as string | undefined) ?? 'https://eu.i.posthog.com';

if (typeof window !== 'undefined' && key) {
  posthog.init(key, {
    api_host: host,
    // Only create person profiles for identified users (guardians).
    // Student and anonymous events remain profile-less — required for COPPA.
    person_profiles: 'identified_only',
    capture_pageview: true,
    capture_pageleave: true,
  });
}

export function posthogCapture(event: string, properties?: Record<string, unknown>): void {
  if (!key) return;
  posthog.capture(event, properties);
}

export function posthogIdentify(distinctId: string, properties?: Record<string, unknown>): void {
  if (!key) return;
  posthog.identify(distinctId, properties);
}

export function posthogReset(): void {
  if (!key) return;
  posthog.reset();
}
